<div id="report">
  <div class="headercontainer"></div>
  <div id="questionscontainer" [innerHTML]="this.html | safeHtml" *ngIf="html"></div>
  <div *ngIf="!html" class="empty-message">
    <p>Exam script is empty</p>
  </div>
</div>
<button id="printPageBtn" [hidden]="!html">Download</button>



<script>
  // Function to create the header section
  function createHeader(headerHtml) {
      const header = document.querySelector('.headercontainer');
      header.appendChild(headerHtml);

      return header;
  }
</script>